import * as React from "react";
import { ReportHistory, cutStatus } from "../api/dataTypes";
import ReactTable from "react-table";
import 'react-table/react-table.css'
import * as TableStyles from "../styles/TableFormats";
import "../styles/Tables.css";
import moment from 'moment';
import matchSorter from 'match-sorter';

interface State {

}

export interface Props {
    cuts: ReportHistory[] | null;
    loading: boolean;
    showWinderColumn: boolean;
}

export class CutRecordsTable extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

  render() {
      return(
        <div className="ReactTable component-standard">
            <ReactTable
                data={this.props.cuts || undefined}
                defaultFilterMethod={(filter, row) => (matchSorter([row[filter.id]], filter.value).length !== 0)}

                // COLUMNS ////////////////////////////////
                columns={[{
                    Header: 'Winder',
                    id: 'systemName',
                    accessor: row => row.systemName,
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    show: this.props.showWinderColumn,
                },  {
                    Header: 'Start Time',
                    id: 'startTime',
                    accessor: row => moment(row.startTime).format('x'),
                    Cell: row => (moment(row.original.startTime).add(moment().utcOffset(), 'm').format(' hh:mm a, MM/DD/YY')),
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    width: 250,
                }, {
                    Header: 'End Time',
                    id:'endTime',
                    accessor: row => moment(row.endTime).format('x'),
                    Cell: row => (moment(row.original.endTime).add(moment().utcOffset(), 'm').format(' hh:mm a, MM/DD/YY')),
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    width: 250
                }, {
                    Header: 'User',
                    accessor: 'userId',
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    // width: 300
                }, {
                    Header: 'Requested Length (ft)',
                    id: 'reqCutLength',
                    accessor: row => Math.round(row.reqCutLength * 100) / 100,
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    // width: 300
                }, {
                    Header: 'Actual Length (ft)',
                    id: 'actualCutLength',
                    accessor: row => Math.round(row.actualCutLength * 100) / 100,
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    // width: 300
                }, {
                    Header: 'Status',
                    id: 'status',
                    accessor: row => cutStatus[row.status],
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    width: 100
                }, {
                    Header: 'Preset #',
                    id: 'presetNumber',
                    accessor: row => row.presetNumber,
                    headerStyle: TableStyles.columnHeaderStyle,
                    style: TableStyles.dataStyle,
                    width: 100
                }
            ]}
                // COLUMNS END //////////////////
                // defaultSortid = {[{id: 'startTime'}]}
                defaultSorted = {[{id: 'startTime', desc: true}]}
                className="-highlight"
                // showPagination={false}
                minRows={5}
                loading={this.props.loading}
            />
        </div>
      );
    }

}